(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sancarlino-master-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){if(!event.target.closest('.scl-final-button'))return;var main=document.querySelector('#scl-product'),cod=main?.querySelector('#rsi_buy_now_button');if(cod&&!cod.disabled){cod.click()}else{main?.scrollIntoView({behavior:'smooth',block:'start'})}});

  } catch(e) { console.error(e); }
})();
})();
